import { call, put, takeEvery } from "redux-saga/effects";

// Customer Redux States
import { UPLOAD_FILE, UPLOAD_MULTI_FILE, POST_IPFS_FILE, UPLOAD_ART } from "./actionTypes";
import { apiFail } from "./actions";

import { postFile, postMultiFile, postIpfsFile, AddArtApi } from "helpers/backend_helper";

function* onAddFile({ payload: { data, callback } }) {
  try {

    const response = yield call(postFile, data);

    if (response.status === "failure") {
      return yield put(apiFail(response.message));
    }
    callback && callback(response);
    yield put(apiFail(""));
  } catch (error) {
    yield put(apiFail(error));
  }
}
function* onAddArt({ payload: { data, callback } }) {
  try {

    const response = yield call(AddArtApi, data);

    if (response.status === "failure") {
      return yield put(apiFail(response.message));
    }
    callback && callback(response);
    yield put(apiFail(""));
  } catch (error) {
    yield put(apiFail(error));
  }
}

function* onAddMultiFile({ payload: { data, callback } }) {
  try {
    const response = yield call(postMultiFile, data);

    if (response.status === "failure") {
      return yield put(apiFail(response.message));
    }
    callback && callback(response);
    yield put(apiFail(""));
  } catch (error) {
    yield put(apiFail(error));
  }
}

function* onAddIpfsFile({ payload: { data, callback } }) {
  try {
    const response = yield call(postIpfsFile, data);

    callback && callback(response);
    if (response.status === "failure") {
      return yield put(apiFail(response.message));
    }
    yield put(apiFail(""));
  } catch (error) {
    callback && callback({ message: "Something went wrong...." });
    yield put(apiFail(error));
  }
}

function* fileSaga() {
  yield takeEvery(UPLOAD_FILE, onAddFile);
  yield takeEvery(UPLOAD_MULTI_FILE, onAddMultiFile);
  yield takeEvery(POST_IPFS_FILE, onAddIpfsFile);
  yield takeEvery(UPLOAD_ART, onAddArt);
}

export default fileSaga;
